<template lang="pug">
  div.development.setting-update
    e-form-modal(
      @closeModal="closeModal"
      @submitModalForm="saveDevelopment()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title ...
        e-form-tabs(
          v-model="tabView"
          :tabs="[{tab1: 'main'},{'storage': 'storage'},{'tools': 'tools'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          div(v-show="tabView === 'tab1'")
            div.body.development
              div.col
                e-form-group(
                  :model="fields"
                  label="Идентификатор"
                  tabView="development"
                  :name="DEVICE_NAME"
                  :disabled="true"
                )

                div.e-form-group.col-block
                  label Версия
                    //button(@click="showLastChanges=!showLastChanges").actions-filter-panel__button.standart.standart-noborder Показать изменения
                  div {{APP_FULL_VERSION}}

                div(v-show="showLastChanges").e-form-group.col-block
                  label Последние изменения
                  textarea(disabled) {{APP_GIT_LAST_CHANGES}}

                div.e-form-group.col-block
                  label Дата компиляции (по гринвичу)
                  div {{APP_LAST_BUILD}}

                e-form-group(
                :model="fields"
                label="Адрес сервера"
                tabView="development"
                name="ROOT_API"
                )
                div.col-block
                  div С внутренней сети:
                  div http://172.19.110.242:100/api/v1/ (Ли)
                  div http://172.19.110.144:100/api/v1/ (Ди)
                  div http://172.19.110.1/api/v1/ (Ни)

                e-form-group(
                :model="fields"
                label="Адрес api демо разделов"
                tabView="development"
                name="ROOT_MONGO_API"
                )
                div.col-block
                  div http://172.19.110.150:3000/mongo/v1/ (Р)

                e-form-group(
                :model="fields"
                inputType="select"
                label="Показывать верстку в меню"
                tabView="development"
                name="SHOW_HTML_IN_MENU"
                :options="disableEnableOptions"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Текущий регион"
                tabView="development"
                name="CURRENT_REGION"
                  :options="regions"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Провайдер адресов"
                tabView="development"
                name="DEFAULT_ADDRESS_PROVIDER"
                :options="addressProviders"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Язык"
                tabView="development"
                name="LOCALE"
                :options="locales"
                )

                e-form-group(
                  :model="fields"
                  inputType="select"
                  label="Чем отображать кластеры на карте"
                  tabView="development"
                  name="OBJECT_RENDERER"
                  :options="OBJECT_RENDERER_OPTIONS"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Показать скрытые поля"
                tabView="development"
                name="SHOW_HIDDEN_FIELDS"
                :options="disableEnableOptions"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Принудительно включить редактирование полей"
                tabView="development"
                name="FORCE_ENABLE_DISABLED_FIELDS"
                :options="disableEnableOptions"
                )

                e-form-group(
                :model="fields"
                inputType="select"
                label="Отобразить подсказки по правам в меню"
                tabView="development"
                name="SHOW_PERMS_TIPS"
                  :options="disableEnableOptions"
                )

              div.col
                e-form-group(
                :model="fields"
                inputType="select"
                label="Перезаписать права сервера на следующие"
                tabView="development"
                name="USE_DEV_PERMS"
                :options="disableEnableOptions"
                )
                e-form-group(
                  :model="customPerms"
                  inputType="checkbox"
                  caption="Разрешение на вывод названия региона в тулбаре"
                  tabView="development"
                  name="show-site-name"
                )
                e-role-editor(
                  :model="fields"
                  name="perms"
                  :permissionList="permissionList"
                )

          div(v-show="tabView === 'storage'")
            div.body.development
              div.col
              p {{fields}}

          div(v-show="tabView === 'tools'")
            div.body.development
              div.col
                br

                button(
                  @click="generateError()"
                ).actions-filter-panel__button.standart.is-full-width generateError()

                button(
                  @click="generateDelayedError()"
                ).actions-filter-panel__button.standart.is-full-width generateDelayedError()

              div.col

              div.col
</template>

<script>
  import {REGION_ROOT_API, DEFAULT_ADDRESS_PROVIDER, USE_DEV_PERMS, FORCE_ENABLE_DISABLED_FIELDS, SHOW_HIDDEN_FIELDS, ROOT_MONGO_API, ROOT_API, SHOW_HTML_IN_MENU, SHOW_PERMS_TIPS, OBJECT_RENDERER} from '../../config/config.js'
  import {SVERD, ORENB, ORLOV, HMAO, KRASNODAR, KALUG, KARELIA, SAAS, TATAR, MARIEL, KURGAN} from '../../config/region'
  import * as regions from '../../config/region.js'
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import region from '../../utils/region.js'
  import {PERMISSIONS_MAP} from '../../config/permissions'
  import {LOCALE, LOCALE_SERVICES_MAP} from "../../config/locale"
  import {getDeviceId, DEVICE_NAME} from "../../utils/random"

  export default {
    title: 'Dev setting',
    mixins: [formBaseMixin],
    name: 'setting-update',
    computed: {
      addressProviders () {
        return [
          {id: 'dadata', name: 'dadata'},
          {id: 'nominatim', name: 'nominatim'},
          {id: 'custom', name: 'custom'},
          {id: 'tree', name: 'tree(Калуга)'}
        ]
      },
      OBJECT_RENDERER_OPTIONS () {
        return [
          {id: 'superclaster', name: 'superclaster'},
          {id: 'default', name: 'Leaflet.markercluster'}
        ]
      },
      DEVICE_NAME () {
        return DEVICE_NAME
      },
      APP_FULL_VERSION () {
        return APP_FULL_VERSION
      },
      APP_LAST_BUILD () {
        return APP_LAST_BUILD
      },
      APP_GIT_LAST_CHANGES () {
        return APP_GIT_LAST_CHANGES
      },
      permissionList () {
        let tmp = []
        for (let key in PERMISSIONS_MAP) {
          let obj = Object.assign({}, PERMISSIONS_MAP[key], {permissions: []})
          if (PERMISSIONS_MAP[key].permissions) {
            for (let permName in PERMISSIONS_MAP[key].permissions) {
              obj.permissions.push({
                id: PERMISSIONS_MAP[key].permissions[permName]
              })
            }
          }
          tmp.push(obj)
        }
        return tmp
      },
      user () {
        return this.$store.getters.userData
      },
      disableEnableOptions () {
        return [
          {id: false, name: 'Выкл'},
          {id: true, name: 'Вкл'}
        ]
      },
      locales () {
        let tmp = []
        for (let locale in LOCALE_SERVICES_MAP) {
          tmp.push({id: locale, name: locale})
        }
        return tmp
      },
      regions () {
        let tmp = []
        try {
          for (let importedKey in regions) {
            tmp.push({
              id: regions[importedKey],
              name: regions[importedKey]
            })
          }
        } catch (e) {
          this.$notify.error({title: 'Не пытайтесь сохранить', message: e.toString()})
        }
        return tmp
      }
    },
    data () {
      return {
        tabView: 'tab1',
        showLastChanges: false,
        customPerms: {
          'show-site-name': false
        },
        fields: {
          USE_DEV_PERMS: USE_DEV_PERMS,
          ROOT_API: ROOT_API,
          ROOT_MONGO_API: ROOT_MONGO_API,
          SHOW_HTML_IN_MENU: SHOW_HTML_IN_MENU,
          CURRENT_REGION: region.getCurrentRegion(),
          SHOW_PERMS_TIPS: SHOW_PERMS_TIPS,
          perms: [],
          FORCE_ENABLE_DISABLED_FIELDS: FORCE_ENABLE_DISABLED_FIELDS,
          SHOW_HIDDEN_FIELDS: SHOW_HIDDEN_FIELDS,
          OBJECT_RENDERER: OBJECT_RENDERER,
          LOCALE: LOCALE,
          DEFAULT_ADDRESS_PROVIDER: DEFAULT_ADDRESS_PROVIDER,
          [DEVICE_NAME]: getDeviceId()
        }
      }
    },
    created () {
      if (this.user) {
        this.fields = Object.assign({}, this.fields, {
          perms: this.user.perms || []
        })
        for (let pKey in this.customPerms) {
          this.customPerms[pKey] = this.user.perms.indexOf(pKey) > -1
        }
      }
    },
    watch: {
      'fields.CURRENT_REGION': function (newVal) {
        let result = confirm('Настроить url api под новый регион?')
        if (result) {
          this.fields.ROOT_API = REGION_ROOT_API[newVal] || REGION_ROOT_API.default

          if (this.fields.ROOT_API) {
            this.fields.ROOT_MONGO_API = this.fields.ROOT_API.toString().replace('/api/v1/', '/mongo/v1/')
          } else {
            this.fields.ROOT_MONGO_API = null
          }
        }
      }
    },
    methods: {
      closeModal () {
        this.$router.push({path: '/'})
      },
      saveDevelopment () {
        for (let pKey in this.customPerms) {
          if (this.customPerms[pKey] === true) {
            this.fields.perms.push(pKey)
          } else {
            this.fields.perms = this.fields.perms.filter(v => v !== pKey)
          }
        }
        this.fields.perms = [...new Set(this.fields.perms)]

        for (let keyName in this.fields) {
          window.localStorage.setItem(keyName, JSON.stringify(this.fields[keyName]))
        }
        // save perms
        if (this.fields.USE_DEV_PERMS) {
          this.$store.commit('userSetAuthData', Object.assign({}, this.user, {
            perms: this.fields.perms
          }))
        }

        this.$notify.success({title: 'Настройки сохранены', message: 'Дождитесь перезагрузки...'})
        setTimeout(() => {
          document.location.reload(true)
        }, 1000)
        this.$router.push({path: '/'})
      },
      generateError () {
        throw new Error('generateError')
      },
      generateDelayedError () {
        setTimeout(() => {
          throw new Error('generateDelayedError')
        }, 0)
      }
    },
    asyncData () {
      return Promise.resolve(1)
    }
  }
</script>
